<div class="page-header">
    <div class="page-header-text">Payment confirmation</div>
</div>
<div class="page-body">
    <div class="body-text">Thank you for your payment and for letting Nationwide help protect what’s most 
        important to you. You can review your payment details below.</div>
    <div class="body-text">You may want to save or print your payment details for your records, They will 
        open in a new tab.</div>
    <div class="body-text" *ngIf="isGracePayment">It may take 1 to 2 business days before the account status will be updated.</div>        
    <div class="body-button-container tM-10px">
        <bolt-button class="body-button" slot="cancel" type="secondary" (click)="onViewPaymentDetails()">View payment
            details</bolt-button>
    </div>
    <div *ngIf="payment && payment.paymentMethod=='Credit Card' && !isPendingPolicy && !isGracePayment">
        <div class="body-heading unbold-heading">Want to sign up for your online account?</div>
        <div class="body-bold body-text">With an online account, you can:</div>
        <ul style="margin-bottom:10px !important">
            <li class="body-text body-text-option">Set up automatic payments</li>
            <li class="body-text body-text-option">View your policy documents</li>
            <li class="body-text body-text-option">See how you’re covered</li>
            <li class="body-text body-text-option">Enroll in paperless options</li>
            <li class="body-text body-text-option">Contact your local agent</li>
            <li class="body-text body-text-option">Update your mailing address</li>
        </ul>
        <div class="body-button-container bM-32px">
            <bolt-button class="body-button" slot="cancel" type="secondary" (click)="signUp()">Sign up for an online
                account</bolt-button>
        </div>
    </div>
    
    <div class="body-text" *ngIf="payment && payment.paymentMethod=='Bank Account' && !hideRecurringPayment && !isGracePayment">
        <bolt-notification class="tM-20px" *ngIf="recurringSignUpFailed">We couldn't set up recurring payments. Please try again.</bolt-notification>
        <div class="body-heading">Want to set up recurring payments?</div>
        <div class="bM-32px">
            Make it easier on yourself, and avoid the risk of your pending policy lapsing. by <br>
            setting up recurring payments from your checking or savings account to pay <br>
            your premium. Choose your payment frequency below and we’ll automatically <br>
            withdraw your premium payment on the schedule you select, using the same <br>
            electronic fund transfer (ACH) method you provided for your initial premium <br>
            payment today. The date of your first payment will be your policy issue date.
        </div>

        <div class="body-text bM-32px">
            If you choose&nbsp;<span class="body-bold">not</span>&nbsp;to set up recurring premium payments today,
            you’ll be
            billed <br>
            whenever your premium is due. You can set up recurring payments at any time <br>
            by contacting our Life Insurance Solutions Center at &nbsp;<span
                class="text-phone">1-800-848-6331</span>&nbsp;or by <br>
            accessing your online account.
        </div>
        <form [formGroup]="myform" id="myform" novalidate>
            <div class="select-label-text">Choose your payment frequency</div>
        <div class="width-50 bM-32px"> 
           
            <bolt-select class="search-field" aria-label="Choose your payment frequency" formControlName="paymentFrequency" required ngDefaultControl
            [error]="myform.get('paymentFrequency')?.touched && !myform.get('paymentFrequency')?.valid?'Please choose a payment frequency.':null">
                <option value="Monthly">Monthly</option>
                <option value="Quarterly">Quarterly</option>
                <option value="Semi-annually">Semi-annually</option>
                <option value="Annual">Annually</option>
            </bolt-select>
        </div>
        </form>
        <div class="text-box">
            <div class="text-box-content body-text">
                <div class="bM-12px">
                    <div class="body-bold">Recurring Automated Clearing House (ACH) authorization</div>
                    <div>
                        By selecting the button below, you authorize Nationwide Life Insurance
                        Company and/or Nationwide Life and Annuity Insurance Company to
                        electronically debit (withdraw) and/or correct by electronic credit
                        (deposit) your life insurance premium payments from the bank account
                        provided and as allowed by U.S. law.
                    </div>
                </div>
                <div class="bM-12px">
                    <span class="body-bold">Date of debit:</span>&nbsp;
                    The debit from your checking or savings account will occur no earlier than the
                    draft date provided above. If the draft date falls on a weekend or holiday, the debit will occur
                    on the next business day after the regularly scheduled draft date.
                </div>
                <div class="bM-12px">
                    <span class="body-bold">Account verification:</span>&nbsp;
                    In processing your 1-time or recurring ACH debit transactions, Nationwide
                    uses consumer information to verify ownership of the bank account to reduce the possibility of
                    fraud. If there is an inconsistency in the information you have provided to us and the
                    authorized bank account holder’s information, or if you fail to provide adequate account
                    information, we will contact you to validate or obtain accurate bank account information.
                </div>
                <div class="bM-12px">
                    <div>
                        <span class="body-bold">For commercial bank account owners only:</span>&nbsp;
                        Each of Nationwide and the Commercial Bank Account Owner identified on this form agree to be
                        bound by Nacha Operating Rules and acknowledges that the origination of ACH transactions to this
                        account must comply with applicable U.S. Law.
                    </div>
                    <ul style="margin-bottom:10px !important">
                        <li class="body-text">Corporate account ownership: Where the owner of the account is a
                            corporation, please provide a corporate resolution or a letter from the company or bank
                            confirming the individual who is authorized to sign checks on behalf of the company. This
                            authorized person must sign this form as the bank account owner.</li>
                        <li class="body-text">Trust ownership: Where the owner of the account is a trust, please provide
                            a Certification of Trust (Trust Certificate) that provides necessary information to validate
                            the trust including but not limited to the legal Trust name and effective date, the
                            Trustee(s) authorized to act on behalf of the Trust (generally and with respect to the trust
                            account indicated on this form) including any successor Trustee(s), and the Trust’s tax
                            identification number.</li>
                    </ul>
                </div>
                <div class="bM-12px">
                    <span class="body-bold">Insufficient funds:</span>&nbsp;
                    If sufficient funds are not available on the draft day, you authorize us to make a second draft
                    attempt within 5 business days. Your bank may charge a fee for these attempts if sufficient funds
                    are not available. Nationwide does not charge a fee for these attempts, but your financial
                    institution might. If sufficient funds are not available after the second attempt, Nationwide will
                    contact you to resolve any issues related to outstanding premium.
                </div>
                <div class="bM-12px">
                    <span class="body-bold">Joint account owners:</span>&nbsp;
                    If this bank account is a joint account, authorization by one bank account owner constitutes
                    authorization by all bank account owners – whether a current owner of this account or added after
                    this authorization is signed.
                </div>
                <div class="bM-12px">
                    <span class="body-bold">Stopping automatic payments:</span>&nbsp;
                    Your authorization allows us to continue taking premium payments from this account (and/or
                    corrections by electronic debit or credit) until you tell us to stop, either upon policy termination
                    or upon the payment of your last scheduled premium payment, whichever occurs first. To withdraw your
                    authorization, you must notify us by contacting our Solutions Center at 1-800-848-6331. Please
                    provide notification to us at least 10 days in advance of when our authorization should end. Doing
                    so allows us and your bank to take action.
                </div>
                <div class="bM-12px">
                    <span class="body-bold">Outstanding balances:</span>&nbsp;
                    If you have a balance due on your policy(ies) after the expiration or cancellation of this
                    authorization, you authorize us to electronically debit this bank account for the outstanding
                    balance.
                </div>
                <div class="bM-12px">
                    <span class="body-bold">Amount changes:</span>&nbsp;
                    If for any reason your scheduled payment changes by an amount greater than or equal to $10, we’ll
                    notify you by sending you an updated summary.
                </div>
            </div>
        </div>
    </div>
    <a href="https://www.nationwide.com/" class="tM-10px" *ngIf="isGracePayment">Return to Nationwide.com</a>
</div>

<div class="page-footer" *ngIf="payment && payment.paymentMethod=='Bank Account' && !hideRecurringPayment && !isGracePayment">
    <bolt-button-bar class="footer-button-bar body-button-container">
        <bolt-button class="body-button" slot="cancel" type="primary" (click)="onSubmit()" >Sign me up for recurring payments</bolt-button>
    </bolt-button-bar>
</div>